import { ButtonMedium, GoogleLoginButton, LoginWithPhoneButton } from "../components/button.component";
import { Input } from "../components/input.component";
import { primaryColor, shadowColor } from "../theme"
import commonCSS, { mobileView } from "../commonCss/commonCss"
import { StyleSheet, css } from "aphrodite";
import { ReactComponent as ShoppingSVG } from "../gone_shopping.svg"
import logo from '../assets/img/sangini_black.png'
import { Link } from "react-router-dom";
import { useState } from "react";
import { useLoginHook } from "../hooks/useLoginHook";

export default function LoginPage({ routeBackTo, shouldLogout }: { routeBackTo?: string, shouldLogout?: boolean }) {
    const { inputEmail, inputPassword, handleLogin, handleGoogleLogin, handleSendOtp, handleVerifyOtp, otpSent, isSending } = useLoginHook({ routeBackTo, shouldLogout });
    const [isPhoneLogin, setIsPhoneLogin] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [otp, setOtp] = useState("");

    return <div className={css(commonCSS.flexRow, styles.loginDiv)}>
        <ShoppingSVG className={css(styles.loginLeftSideView)}></ShoppingSVG>
        <div className={css(commonCSS.flexColumn, commonCSS.alignItemsCenter, styles.loginRightSideView)}>
            <div className={css(commonCSS.flexColumn, commonCSS.alignItemsCenter)}>
                <img src={logo} alt="Sangini Jewellers" className={css(styles.loginHeaderLogo)} />
                <div className={css(styles.loginTextHeader)}>{isPhoneLogin ? "Phone Login" : "Login"}</div>
                <div className={css(styles.loginTextSubHeader)}>Please Sign in to Continue</div>

                {!isPhoneLogin ? (
                    <>
                        <Input className={css(commonCSS.marginTB10)} type="text" placeholder="Enter email" autoFocus={true} onChangeValue={(val) => { inputEmail.current = val }} />
                        <Input className={css(commonCSS.marginTB10)} type="password" placeholder="Enter password" onChangeValue={(val) => { inputPassword.current = val }} />
                        <Link to={"/forgotPassword"} className={css(commonCSS.noLinkDecoration, commonCSS.alignSelfFlexEnd, styles.forgotPassword)}>Forgot password? </Link>
                        <Link to={"/signup"} className={css(commonCSS.noLinkDecoration, commonCSS.alignSelfFlexEnd, styles.forgotPassword)}>Don't have an account? click here </Link>
                        <ButtonMedium className={css(styles.loginButton)} text="Login" color={primaryColor} onClick={handleLogin} />
                    </>
                ) : (
                    <>
                        {/* Recaptcha container must persist in DOM */}
                        <div id="recaptcha-container"></div>

                        {!otpSent ? (
                            <>
                                <Input className={css(commonCSS.marginTB10)} type="tel" value={phoneNumber} placeholder="Enter phone number (e.g. +91...)" autoFocus={true} onChangeValue={(val) => { setPhoneNumber(val) }} />
                                <ButtonMedium
                                    className={css(styles.loginButton)}
                                    text={isSending ? "Sending..." : "Send OTP"}
                                    color={primaryColor}
                                    onClick={() => handleSendOtp(phoneNumber)}
                                    disabled={isSending}
                                />
                            </>
                        ) : (
                            <>
                                <div style={{ fontSize: '0.9rem', color: '#555', marginBottom: '10px' }}>OTP sent to: <strong>{phoneNumber}</strong></div>
                                <Input className={css(commonCSS.marginTB10)} type="text" value={otp} placeholder="Enter OTP" autoFocus={true} onChangeValue={(val) => { setOtp(val) }} />
                                <ButtonMedium className={css(styles.loginButton)} text="Verify OTP" color={primaryColor} onClick={() => handleVerifyOtp(otp)} />
                            </>
                        )}
                        <div style={{ alignSelf: 'flex-end', cursor: 'pointer', color: primaryColor, fontSize: '0.8rem', marginTop: '10px' }} onClick={() => setIsPhoneLogin(false)}>
                            Back to Email Login
                        </div>
                    </>
                )}

                <span style={{ marginBottom: '1rem', fontSize: '1rem', marginTop: '1rem' }}>or</span>
                <GoogleLoginButton onClick={handleGoogleLogin} title="Login with Google" />
                <br/>
                <LoginWithPhoneButton onClick={() => setIsPhoneLogin(true)} />
            </div>
        </div>
    </div>
}

const styles = StyleSheet.create({
    loginDiv: {
        [mobileView]: {
            flexDirection: "column"
        }
    },
    loginLeftSideView: {
        paddingTop: "1rem",
        flex: 1,
        height: "calc(100vh - 90px - 1rem)",
        [mobileView]: {
            display: "none"
        }
    },
    loginRightSideView: {
        paddingTop: "2rem",
        flex: 1,
        justifyContent: "flex-start"
    },
    loginHeaderLogo: {
        height: "10rem"
    },
    loginTextHeader: {
        width: "20rem",
        margin: "50px 0 10px 0",
        fontSize: "1.5rem",
        fontWeight: "bold",
        alignSelf: "flex-start",
    },
    loginTextSubHeader: {
        width: "20rem",
        alignSelf: "flex-start",
        color: "#222",
        margin: "0px 0 15px 0",
        fontFamily: "'Ubuntu', sans-serif"
    },
    loginButton: {
        margin: "20px 0"
    },
    forgotPassword: {
        fontSize: "0.8rem",
        color: primaryColor,
        ":any-link": {
            color: shadowColor
        }
    },

})